/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSkillSuggestionsResult,
  ListSkillSuggestionsResult$inboundSchema,
} from "../components/listskillsuggestionsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSkillSuggestionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSkillSuggestionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSkillSuggestionsSecurity = {
  option1?: ListSkillSuggestionsSecurityOption1 | undefined;
  option2?: ListSkillSuggestionsSecurityOption2 | undefined;
};

export type ListSkillSuggestionsRequest = {
  /**
   * Only return suggestions for this skill.
   */
  skillId?: string | undefined;
  /**
   * Cursor for the next page of suggestions.
   */
  cursor?: string | undefined;
  /**
   * The number of suggestions to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListSkillSuggestionsResponse = {
  result: ListSkillSuggestionsResult;
};

/** @internal */
export type ListSkillSuggestionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSkillSuggestionsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSkillSuggestionsSecurityOption1$Outbound,
  ListSkillSuggestionsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSkillSuggestionsSecurityOption1ToJSON(
  listSkillSuggestionsSecurityOption1: ListSkillSuggestionsSecurityOption1,
): string {
  return JSON.stringify(
    ListSkillSuggestionsSecurityOption1$outboundSchema.parse(
      listSkillSuggestionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSkillSuggestionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSkillSuggestionsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSkillSuggestionsSecurityOption2$Outbound,
  ListSkillSuggestionsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSkillSuggestionsSecurityOption2ToJSON(
  listSkillSuggestionsSecurityOption2: ListSkillSuggestionsSecurityOption2,
): string {
  return JSON.stringify(
    ListSkillSuggestionsSecurityOption2$outboundSchema.parse(
      listSkillSuggestionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSkillSuggestionsSecurity$Outbound = {
  Option1?: ListSkillSuggestionsSecurityOption1$Outbound | undefined;
  Option2?: ListSkillSuggestionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSkillSuggestionsSecurity$outboundSchema: z.ZodMiniType<
  ListSkillSuggestionsSecurity$Outbound,
  ListSkillSuggestionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSkillSuggestionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSkillSuggestionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSkillSuggestionsSecurityToJSON(
  listSkillSuggestionsSecurity: ListSkillSuggestionsSecurity,
): string {
  return JSON.stringify(
    ListSkillSuggestionsSecurity$outboundSchema.parse(
      listSkillSuggestionsSecurity,
    ),
  );
}

/** @internal */
export type ListSkillSuggestionsRequest$Outbound = {
  skill_id?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSkillSuggestionsRequest$outboundSchema: z.ZodMiniType<
  ListSkillSuggestionsRequest$Outbound,
  ListSkillSuggestionsRequest
> = z.pipe(
  z.object({
    skillId: z.optional(z.string()),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 20),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      skillId: "skill_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSkillSuggestionsRequestToJSON(
  listSkillSuggestionsRequest: ListSkillSuggestionsRequest,
): string {
  return JSON.stringify(
    ListSkillSuggestionsRequest$outboundSchema.parse(
      listSkillSuggestionsRequest,
    ),
  );
}

/** @internal */
export const ListSkillSuggestionsResponse$inboundSchema: z.ZodMiniType<
  ListSkillSuggestionsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSkillSuggestionsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listSkillSuggestionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillSuggestionsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillSuggestionsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillSuggestionsResponse' from JSON`,
  );
}
